import { render, staticRenderFns } from "./AuctionArena.vue?vue&type=template&id=5095d3ff&scoped=true"
import script from "./AuctionArena.vue?vue&type=script&lang=js"
export * from "./AuctionArena.vue?vue&type=script&lang=js"
import style0 from "./AuctionArena.vue?vue&type=style&index=0&id=5095d3ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095d3ff",
  null
  
)

export default component.exports